<template>
  <v-row>
    <v-col cols="6" :style="`overflow: auto; height: ${height}; z-index: 0`">
      <VueCodeditor v-model="values" mode="javascript" theme="monokai" />
    </v-col>
    <v-col cols="6" style="padding: 0">
      <iframe :srcdoc="values" width="100%" height="100%"></iframe>
    </v-col>
  </v-row>
</template>
<script>
import VueCodeditor from "vue-codeditor";

export default {
  name: "HtmlViewer",
  components: { VueCodeditor },
  data: () => ({}),
  props: {
    value: { type: String },
    height: { type: String, default: "70vh" },
  },
  computed: {
    values: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
<style lang="sass" scoped></style>
